import { gql } from "@apollo/client";

export const UPDATE_SUBSCRIPTION = gql`
mutation UpdateSubscription($input: UpdateSubscriptionInput) {
  updateSubscription(input: $input) 
}
`; 

export const GET_SUBSCRIPTION = gql`
  query GetSubscription($businessUrl: String!) {
    getSubscription(businessUrl: $businessUrl) {
      id
      planId 
      subscribedOnDate
      unsubscribedOnDate
      pendingEffectiveDate
      pendingPlanId   
      businessName  
    }
  }
`;